<template>
  <div class="col-12">
    <div class=" row text-center m-5">
      <h3 class="ui inverted purple text"><strong> Customer Details</strong></h3>
      <p class="text-muted fw-light mr-4 ml-4">Change the details if the populated information is incorrect.</p>
    </div>
    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-11 col-lg-10">
        <form class="ui form" @submit.prevent="submitForm()">

          <div class="card">
            <div class="card-header">
            </div>
            <div class="card-body">
              <h4 class="ui dividing header">Personal Information</h4>
              <div class="field">
                <div class="fields">
                  <div class="eight wide field">
                    <label>Mobile Number</label>
                    <input type="number" name="mobileNumber" v-model="customer.mobileNumber" disabled
                      placeholder="Mobile Number">
                    <small v-if="errors.phone" class="text-danger">{{ errors.phone }}</small>
                  </div>

                  <div class="eight wide field">
                    <label>Email</label>
                    <input type="text" name="email" v-model="customer.email" placeholder="Email">
                    <small v-if="!isEmailValid" class="text-danger mt-1">
                      The Email is required
                    </small>
                  </div>
                  <div class="eight wide field">
                    <label>Branch</label>
                    <select class="ui fluid dropdown" v-model="customer.branch">
                      <option value="">Select Branch</option>
                      <option v-for="branch of model.branch" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
                    </select>
                    <small v-if="!isBranchValid" class="text-danger mt-1">
                      The Branch is required
                    </small>
                  </div>

                </div>
              </div>
              <div class="field">
                <label>Full Name</label>
                <div class="three fields">
                  <div class="field">
                    <select class="ui fluid dropdown" v-model="customer.title">
                      <option value="">Select Title</option>
                      <option v-for="title of model.title" :key="title.name">{{ title.name }}</option>
                    </select>
                    <small v-if="!isTitleValid" class="text-danger mt-1">
                      The Title is required
                    </small>
                    <small v-if="!isTitleNameValid" class="text-danger mt-1">
                      The Title and Gender are not matching
                    </small>
                  </div>
                  <div class="field">
                    <input type="text" name="firstName" v-model="customer.firstName" placeholder="First Name">
                    <small v-if="!isFirstNameValid" class="text-danger mt-1">
                      The First Name is required
                    </small>
                  </div>
                  <div class="field">
                    <input type="text" name="lastName" v-model="customer.lastName" placeholder="Last Name">
                    <small v-if="!isLastNameValid" class="text-danger mt-1">
                      The Last Name is required
                    </small>
                  </div>
                </div>
              </div>
              <div class="field fluid left icon input mt-4 d-flex flex-column">
                <label>Date Of Birth</label>
                <a-date-picker size="large" v-model:value="customer.dateOfBirth"></a-date-picker>
                <small v-if="!isDOBValid" class="text-danger mt-1">
                  The Date Of Birth is required and should be 18 years and above!
                </small>
              </div>
              <div class="field">
                <div class="fields">
                  <div class="eight wide field">
                    <label>National ID Number</label>
                    <input type="text" name="identityDocNo" v-model="customer.identityDocNo"
                      placeholder="National ID Number">
                    <small v-if="!isIdNumberValid" class="text-danger mt-1">
                      The National ID Number is required
                    </small>
                  </div>

                  <div class="eight wide field">
                    <label>Gender</label>
                    <select class="ui fluid dropdown" v-model="customer.gender">
                      <option value="">Select Gender</option>
                      <option v-for="gender of model.gender" :key="gender.name">{{ gender.name }}</option>
                    </select>
                    <small v-if="!isGenderValid" class="text-danger mt-1">
                      The Gender is required
                    </small>
                    <small v-if="!isTitleNameValid" class="text-danger mt-1">
                      The Title and Gender are not matching
                    </small>
                  </div>

                </div>
              </div>

              <div class="field">
                <div class="fields">
                  <div class="eight wide field">
                    <label>Marital Status</label>
                    <select class="ui fluid dropdown" v-model="customer.maritalStatus">
                      <option value="">Select Marital Status</option>
                      <option v-for="maritalStatus of model.maritalStatus" :key="maritalStatus.name">{{
                          maritalStatus.name
                      }}</option>
                    </select>
                    <small v-if="!isMaritalStatusValid" class="text-danger mt-1">
                      The Marital Status is required
                    </small>
                  </div>

                </div>
              </div>
              <div class="field">
                <label>Address</label>
                <div class="three fields">
                  <div class="field">
                    <input type="text" name="street" v-model="customer.street" placeholder="Street Address">
                    <small v-if="!isStreetValid" class="text-danger mt-1">
                      The Street Address is required
                    </small>
                  </div>
                  <div class="field">
                    <input type="text" name="town" v-model="customer.town" placeholder="Town or City">
                    <small v-if="!isTownValid" class="text-danger mt-1">
                      The Town Or City is required
                    </small>
                  </div>
                  <div class="field">
                    <select class="ui fluid dropdown" v-model="customer.country">
                      <option value="">Select Country</option>
                      <option v-for="country of model.country" :key="country.abbreviation" :value="country.abbreviation">{{ country.name }}</option>
                    </select>
                      <small v-if="!isCountryValid" class="text-danger mt-1">
                        The Country is required
                      </small>
                    </div>
                </div>
              </div>
              <div class="field">
                <label>Income Details</label>
                <div class="two fields">
                  <div class="field">
                    <input type="text" name="monthlyIncomeAmount" v-model="customer.monthlyIncomeAmount"
                      placeholder="Monthly Income">
                    <small v-if="!isMonthlyIncomeAmountValid" class="text-danger mt-1">
                      The Monthly Income is required
                    </small>
                  </div>
                  <div class="field">
                    <input type="text" name="sourceOfIncome" v-model="customer.sourceOfIncome"
                      placeholder="Source Of Income">
                    <small v-if="!isSourceOfIncomeValid" class="text-danger mt-1">
                      The Source Of Income is required
                    </small>
                  </div>
                </div>
              </div>

              <div class="field">
                <div class="fields">
                  <div class="eight wide field">
                    <label>Activity Expected On The Account</label>
                    <input type="text" name="activityExpectedOnAccount" v-model="customer.activityExpectedOnAccount"
                      placeholder="Activity Expected On The Account">
                    <small v-if="!isActivityExpectedOnAccountValid" class="text-danger mt-1">
                      The Activity Expected On The Account is required
                    </small>
                  </div>

                  <div class="eight wide field">
                    <label>Line Of Business</label>
                    <input type="text" name="lineOfBusiness" v-model="customer.lineOfBusiness"
                      placeholder="Line Of Business">
                    <small v-if="!isLineOfBusinessValid" class="text-danger mt-1">
                      The Line Of Business is required
                    </small>
                  </div>

                </div>
              </div>
            </div>
            <div class="card-footer">
              <button class="ui button  purple fluid mt-4" :disabled="!isFormValid" type="submit">Next</button>
              <button class="ui button  grey fluid mt-4 mb-4" @click="back()">Back</button>

            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import dayjs from "dayjs";

export default {
  name: "DiasporaCustomerDetails",
  data() {
    return {
      customer: {
        mobileNumber: localStorage.getItem("phone-number"),
        title: "",
        firstName: "",
        lastName: "",
        identityDocNo: "",
        gender: "",
        branch: "",
        maritalStatus: "",
        email: "",
        town: "",
        street: "",
        monthlyIncomeAmount: "",
        activityExpectedOnAccount: "",
        sourceOfIncome: "",
        lineOfBusiness: "",
        gotCustomerData: false,
        requestType: "FETCH_CUSTOMER_DETAILS",
        dateOfBirth: null,
        country: ""
      }, accountCreationRequest: {
        mobileNumber: localStorage.getItem("phone-number"),
        requestType: "FETCH_CUSTOMER_DETAILS",
      },
      model: {
        gender: [{ name: "MALE" }, { name: "FEMALE" }],
        title: [
          { name: "MR" },
          { name: "MRS" },
          { name: "MISS" },
        ],
        maritalStatus: [{ name: "Single" }, { name: "Married" }, { name: "Widowed" }, { name: "Divorced" }, { name: "Separated" }],
        branch: [
        { id: 1003, name: 'Eastgate' },
        { id: 1004, name: 'Kwame Nkrumah' },
        { id: 1005, name: 'Joina City' },
        { id: 1006, name: 'Avondale' },
        { id: 1007, name: 'Diaspora Banking' },
        { id: 1008, name: 'Mutare' },
        { id: 1009, name: 'Gweru' },
        { id: 1010, name: 'Bulawayo' },
        { id: 1011, name: 'Masvingo' },
        { id: 1012, name: 'Millenial Club' },
        { id: 1013, name: 'Platinum' },
        { id: 1014, name: 'Borrowdale Platinum' },
        { id: 1015, name: 'Victoria Falls' },
        { id: 1016, name: 'Bradfield' }],
        country: [
            { name: 'Afghanistan', abbreviation: 'AF' },
            { name: 'Albania', abbreviation: 'AL' },
            { name: 'Algeria', abbreviation: 'DZ' },
            { name: 'Andorra', abbreviation: 'AD' },
            { name: 'Angola', abbreviation: 'AO' },
            { name: 'Antigua and Barbuda', abbreviation: 'AG' },
            { name: 'Argentina', abbreviation: 'AR' },
            { name: 'Armenia', abbreviation: 'AM' },
            { name: 'Australia', abbreviation: 'AU' },
            { name: 'Austria', abbreviation: 'AT' },
            { name: 'Azerbaijan', abbreviation: 'AZ' },
            { name: 'Bahamas', abbreviation: 'BS' },
            { name: 'Bahrain', abbreviation: 'BH' },
            { name: 'Bangladesh', abbreviation: 'BD' },
            { name: 'Barbados', abbreviation: 'BB' },
            { name: 'Belarus', abbreviation: 'BY' },
            { name: 'Belgium', abbreviation: 'BE' },
            { name: 'Belize', abbreviation: 'BZ' },
            { name: 'Benin', abbreviation: 'BJ' },
            { name: 'Bhutan', abbreviation: 'BT' },
            { name: 'Bolivia', abbreviation: 'BO' },
            { name: 'Bosnia and Herzegovina', abbreviation: 'BA' },
            { name: 'Botswana', abbreviation: 'BW' },
            { name: 'Brazil', abbreviation: 'BR' },
            { name: 'Brunei', abbreviation: 'BN' },
            { name: 'Bulgaria', abbreviation: 'BG' },
            { name: 'Burkina Faso', abbreviation: 'BF' },
            { name: 'Burundi', abbreviation: 'BI' },
            { name: 'Cabo Verde', abbreviation: 'CV' },
            { name: 'Cambodia', abbreviation: 'KH' },
            { name: 'Cameroon', abbreviation: 'CM' },
            { name: 'Canada', abbreviation: 'CA' },
            { name: 'Central African Republic', abbreviation: 'CF' },
            { name: 'Chad', abbreviation: 'TD' },
            { name: 'Chile', abbreviation: 'CL' },
            { name: 'China', abbreviation: 'CN' },
            { name: 'Colombia', abbreviation: 'CO' },
            { name: 'Comoros', abbreviation: 'KM' },
            { name: 'Congo', abbreviation: 'CG' },
            { name: 'Costa Rica', abbreviation: 'CR' },
            { name: 'Croatia', abbreviation: 'HR' },
            { name: 'Cuba', abbreviation: 'CU' },
            { name: 'Cyprus', abbreviation: 'CY' },
            { name: 'Czechia', abbreviation: 'CZ' },
            { name: 'Denmark', abbreviation: 'DK' },
            { name: 'Djibouti', abbreviation: 'DJ' },
            { name: 'Dominica', abbreviation: 'DM' },
            { name: 'Dominican Republic', abbreviation: 'DO' },
            { name: 'East Timor', abbreviation: 'TL' },
            { name: 'Ecuador', abbreviation: 'EC' },
            { name: 'Egypt', abbreviation: 'EG' },
            { name: 'El Salvador', abbreviation: 'SV' },
            { name: 'Equatorial Guinea', abbreviation: 'GQ' },
            { name: 'Eritrea', abbreviation: 'ER' },
            { name: 'Estonia', abbreviation: 'EE' },
            { name: 'Eswatini', abbreviation: 'SZ' },
            { name: 'Ethiopia', abbreviation: 'ET' },
            { name: 'Fiji', abbreviation: 'FJ' },
            { name: 'Finland', abbreviation: 'FI' },
            { name: 'France', abbreviation: 'FR' },
            { name: 'Gabon', abbreviation: 'GA' },
            { name: 'Gambia', abbreviation: 'GM' },
            { name: 'Georgia', abbreviation: 'GE' },
            { name: 'Germany', abbreviation: 'DE' },
            { name: 'Ghana', abbreviation: 'GH' },
            { name: 'Greece', abbreviation: 'GR' },
            { name: 'Grenada', abbreviation: 'GD' },
            { name: 'Guatemala', abbreviation: 'GT' },
            { name: 'Guinea', abbreviation: 'GN' },
            { name: 'Guinea-Bissau', abbreviation: 'GW' },
            { name: 'Guyana', abbreviation: 'GY' },
            { name: 'Haiti', abbreviation: 'HT' },
            { name: 'Honduras', abbreviation: 'HN' },
            { name: 'Hungary', abbreviation: 'HU' },
            { name: 'Iceland', abbreviation: 'IS' },
            { name: 'India', abbreviation: 'IN' },
            { name: 'Indonesia', abbreviation: 'ID' },
            { name: 'Iran', abbreviation: 'IR' },
            { name: 'Iraq', abbreviation: 'IQ' },
            { name: 'Ireland', abbreviation: 'IE' },
            { name: 'Israel', abbreviation: 'IL' },
            { name: 'Italy', abbreviation: 'IT' },
            { name: 'Jamaica', abbreviation: 'JM' },
            { name: 'Japan', abbreviation: 'JP' },
            { name: 'Jordan', abbreviation: 'JO' },
            { name: 'Kazakhstan', abbreviation: 'KZ' },
            { name: 'Kenya', abbreviation: 'KE' },
            { name: 'Kiribati', abbreviation: 'KI' },
            { name: 'Korea, North', abbreviation: 'KP' },
            { name: 'Korea, South', abbreviation: 'KR' },
            { name: 'Kosovo', abbreviation: 'XK' },
            { name: 'Kuwait', abbreviation: 'KW' },
            { name: 'Kyrgyzstan', abbreviation: 'KG' },
            { name: 'Laos', abbreviation: 'LA' },
            { name: 'Latvia', abbreviation: 'LV' },
            { name: 'Lebanon', abbreviation: 'LB' },
            { name: 'Lesotho', abbreviation: 'LS' },
            { name: 'Liberia', abbreviation: 'LR' },
            { name: 'Libya', abbreviation: 'LY' },
            { name: 'Liechtenstein', abbreviation: 'LI' },
            { name: 'Lithuania', abbreviation: 'LT' },
            { name: 'Luxembourg', abbreviation: 'LU' },
            { name: 'Madagascar', abbreviation: 'MG' },
            { name: 'Malawi', abbreviation: 'MW' },
            { name: 'Malaysia', abbreviation: 'MY' },
            { name: 'Maldives', abbreviation: 'MV' },
            { name: 'Mali', abbreviation: 'ML' },
            { name: 'Malta', abbreviation: 'MT' },
            { name: 'Marshall Islands', abbreviation: 'MH' },
            { name: 'Mauritania', abbreviation: 'MR' },
            { name: 'Mauritius', abbreviation: 'MU' },
            { name: 'Mexico', abbreviation: 'MX' },
            { name: 'Micronesia', abbreviation: 'FM' },
            { name: 'Moldova', abbreviation: 'MD' },
            { name: 'Monaco', abbreviation: 'MC' },
            { name: 'Mongolia', abbreviation: 'MN' },
            { name: 'Montenegro', abbreviation: 'ME' },
            { name: 'Morocco', abbreviation: 'MA' },
            { name: 'Mozambique', abbreviation: 'MZ' },
            { name: 'Myanmar', abbreviation: 'MM' },
            { name: 'Namibia', abbreviation: 'NA' },
            { name: 'Nauru', abbreviation: 'NR' },
            { name: 'Nepal', abbreviation: 'NP' },
            { name: 'Netherlands', abbreviation: 'NL' },
            { name: 'New Zealand', abbreviation: 'NZ' },
            { name: 'Nicaragua', abbreviation: 'NI' },
            { name: 'Niger', abbreviation: 'NE' },
            { name: 'Nigeria', abbreviation: 'NG' },
            { name: 'North Macedonia', abbreviation: 'MK' },
            { name: 'Norway', abbreviation: 'NO' },
            { name: 'Oman', abbreviation: 'OM' },
            { name: 'Pakistan', abbreviation: 'PK' },
            { name: 'Palau', abbreviation: 'PW' },
            { name: 'Panama', abbreviation: 'PA' },
            { name: 'Papua New Guinea', abbreviation: 'PG' },
            { name: 'Paraguay', abbreviation: 'PY' },
            { name: 'Peru', abbreviation: 'PE' },
            { name: 'Philippines', abbreviation: 'PH' },
            { name: 'Poland', abbreviation: 'PL' },
            { name: 'Portugal', abbreviation: 'PT' },
            { name: 'Qatar', abbreviation: 'QA' },
            { name: 'Romania', abbreviation: 'RO' },
            { name: 'Russia', abbreviation: 'RU' },
            { name: 'Rwanda', abbreviation: 'RW' },
            { name: 'Saint Kitts and Nevis', abbreviation: 'KN' },
            { name: 'Saint Lucia', abbreviation: 'LC' },
            { name: 'Saint Vincent and the Grenadines', abbreviation: 'VC' },
            { name: 'Samoa', abbreviation: 'WS' },
            { name: 'San Marino', abbreviation: 'SM' },
            { name: 'Sao Tome and Principe', abbreviation: 'ST' },
            { name: 'Saudi Arabia', abbreviation: 'SA' },
            { name: 'Senegal', abbreviation: 'SN' },
            { name: 'Serbia', abbreviation: 'RS' },
            { name: 'Seychelles', abbreviation: 'SC' },
            { name: 'Sierra Leone', abbreviation: 'SL' },
            { name: 'Singapore', abbreviation: 'SG' },
            { name: 'Slovakia', abbreviation: 'SK' },
            { name: 'Slovenia', abbreviation: 'SI' },
            { name: 'Solomon Islands', abbreviation: 'SB' },
            { name: 'Somalia', abbreviation: 'SO' },
            { name: 'South Africa', abbreviation: 'ZA' },
            { name: 'South Sudan', abbreviation: 'SS' },
            { name: 'Spain', abbreviation: 'ES' },
            { name: 'Sri Lanka', abbreviation: 'LK' },
            { name: 'Sudan', abbreviation: 'SD' },
            { name: 'Suriname', abbreviation: 'SR' },
            { name: 'Sweden', abbreviation: 'SE' },
            { name: 'Switzerland', abbreviation: 'CH' },
            { name: 'Syria', abbreviation: 'SY' },
            { name: 'Taiwan', abbreviation: 'TW' },
            { name: 'Tajikistan', abbreviation: 'TJ' },
            { name: 'Tanzania', abbreviation: 'TZ' },
            { name: 'Thailand', abbreviation: 'TH' },
            { name: 'Togo', abbreviation: 'TG' },
            { name: 'Tonga', abbreviation: 'TO' },
            { name: 'Trinidad and Tobago', abbreviation: 'TT' },
            { name: 'Tunisia', abbreviation: 'TN' },
            { name: 'Turkey', abbreviation: 'TR' },
            { name: 'Turkmenistan', abbreviation: 'TM' },
            { name: 'Tuvalu', abbreviation: 'TV' },
            { name: 'Uganda', abbreviation: 'UG' },
            { name: 'Ukraine', abbreviation: 'UA' },
            { name: 'United Arab Emirates', abbreviation: 'AE' },
            { name: 'United Kingdom', abbreviation: 'GB' },
            { name: 'United States', abbreviation: 'US' },
            { name: 'Uruguay', abbreviation: 'UY' },
            { name: 'Uzbekistan', abbreviation: 'UZ' },
            { name: 'Vanuatu', abbreviation: 'VU' },
            { name: 'Vatican City', abbreviation: 'VA' },
            { name: 'Venezuela', abbreviation: 'VE' },
            { name: 'Vietnam', abbreviation: 'VN' },
            { name: 'Yemen', abbreviation: 'YE' },
            { name: 'Zambia', abbreviation: 'ZM' },
        ]
      },
      errors: {},
      operations: 0,
    };
  },
  mounted() {
    this.postNoAuthAndNoBaseUrl(
      URLS.processAccount,
      this.accountCreationRequest,
      "Got Customer Data",
      null,
      true
    ).then((res) => {
      if (!res) return;
      if (res.errors) return (this.errors = res.errors);
      if (res.body.status === "COMPLETE") {
        this.customer.title = res.body.title;
        this.customer.firstName = res.body.firstName;
        this.customer.lastName = res.body.lastName;
        this.customer.identityDocNo = res.body.idNumber;
        this.customer.street = res.body.street;
        this.customer.gender = res.body.gender;
        this.customer.currency = localStorage.getItem("currency-type");
        this.customer.town = res.body.town;
        this.customer.gotCustomerData = true;
        this.customer.dateOfBirth = res.body?.dateOfBirth ? dayjs(res.body.dateOfBirth) : null;
        this.customer.button = "Confirm Your Details";
        this.customer.requestType = "PRE_PROCESS_DIASPORA_ACCOUNT";
        this.customer.header = "Please Confirm Your Customer Details";
        // Populate email from API response if available
        if (res.body.email) {
          this.customer.email = res.body.email;
        }
      } else {
        //   this.$router.push("/account-opening/isave-failed");
      }
    });
  },
  computed: {
    isFirstNameValid() {
      return !!this.customer.firstName;
    },
    isLastNameValid() {
      return !!this.customer.lastName;
    },
    isStreetValid() {
      return !!this.customer.street;
    },
    isTownValid() {
      return !!this.customer.town;
    },
    isIdNumberValid() {
      return !!this.customer.identityDocNo && /([0-9]{8,9}[a-z,A-Z][0-9]{2}$)/g.test(this.customer.identityDocNo);
    },
    isEmailValid() {
      return !!this.customer.email && /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.customer.email);
    },
    isGenderValid() {
      return !!this.customer.gender;
    },
    isBranchValid() {
      return !!this.customer.branch;
    },
    isMaritalStatusValid() {
      return !!this.customer.maritalStatus;
    },
    isDOBValid() {
      return !!this.customer.dateOfBirth && dayjs().diff(this.customer.dateOfBirth, 'years') >= 18;
    },
    isTitleValid() {
      return !!this.customer.title;
    },
    isTitleNameValid() {
      if (this.customer.gender === 'MALE') {
        return this.customer.title === 'MR';
      } else if (this.customer.gender === 'FEMALE') {
        return this.customer.title === 'MRS' || this.customer.title === 'MISS';
      } else {
        return false;
      }
    },
    isMonthlyIncomeAmountValid() {
      return !!this.customer.monthlyIncomeAmount;
    },
    isActivityExpectedOnAccountValid() {
      return !!this.customer.activityExpectedOnAccount;
    },
    isSourceOfIncomeValid() {
      return !!this.customer.sourceOfIncome;
    },
    isLineOfBusinessValid() {
      return !!this.customer.lineOfBusiness;
    },
    isCountryValid() {
      return !!this.customer.country;
    },
    isFormValid() {
      return (
        this.isFirstNameValid &&
        this.isLastNameValid &&
        this.isTownValid &&
        this.isStreetValid &&
        this.isIdNumberValid &&
        this.isGenderValid &&
        this.isBranchValid &&
        this.isDOBValid &&
        this.isTitleValid &&
        this.isTitleNameValid &&
        this.isMaritalStatusValid &&
        this.isMonthlyIncomeAmountValid &&
        this.isActivityExpectedOnAccountValid &&
        this.isSourceOfIncomeValid &&
        this.isLineOfBusinessValid &&
        this.isEmailValid &&
        this.isCountryValid
      );
    },
  },
  methods: {
    back() {
      this.$router.push("/account-opening/diaspora-currency-type");
    },
    submitForm() {
      if (this.isFormValid) {
        localStorage.setItem("first-name", this.customer.firstName);
        localStorage.setItem("last-name", this.customer.lastName);
        localStorage.setItem("identity-doc-no", this.customer.identityDocNo);
        localStorage.setItem("email", this.customer.email);
        localStorage.setItem("street", this.customer.street);
        localStorage.setItem("currency", this.customer.currency);
        localStorage.setItem("gender", this.customer.gender);
        localStorage.setItem("branch", this.customer.branch);
        localStorage.setItem("maritalStatus", this.customer.maritalStatus);
        localStorage.setItem("title", this.customer.title);
        localStorage.setItem("town", this.customer.town);
        localStorage.setItem("dateOfBirth", dayjs(this.customer.dateOfBirth).format("MM-DD-YYYY"));
        localStorage.setItem("monthlyIncomeAmount", this.customer.monthlyIncomeAmount);
        localStorage.setItem("activityExpectedOnAccount", this.customer.activityExpectedOnAccount);
        localStorage.setItem("sourceOfIncome", this.customer.sourceOfIncome);
        localStorage.setItem("lineOfBusiness", this.customer.lineOfBusiness);
        localStorage.setItem("country", this.customer.country);
        this.$router.push("/account-opening/diaspora-signature");
      } else {
        console.log("Error Sumitting");
      }
    },
    ...baseMethods,
  },
};
</script>
